var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCrossWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31149 3.74144C4.15212 3.61753 3.92168 3.62879 3.77524 3.77524C3.61659 3.93389 3.61659 4.19111 3.77524 4.34976L5.92607 6.5006L3.77524 8.65143C3.61659 8.81009 3.61659 9.06731 3.77524 9.22596C3.92168 9.37241 4.15212 9.38367 4.31149 9.25975L4.34976 9.22596L6.5006 7.07512L8.65143 9.22596L8.68971 9.25975C8.84907 9.38367 9.07951 9.37241 9.22596 9.22596C9.38461 9.06731 9.38461 8.81009 9.22596 8.65143L7.07512 6.5006L9.22596 4.34976C9.38461 4.19111 9.38461 3.93389 9.22596 3.77524C9.07951 3.62879 8.84907 3.61753 8.68971 3.74144L8.65143 3.77524L6.5006 5.92607L4.34976 3.77524L4.31149 3.74144Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossWhite);
export default __webpack_public_path__ + "static/media/icon_cross_white.4de4269581f202360e0ba6ca01593341.svg";
export { ForwardRef as ReactComponent };